import { WEBSERVICE_ERRORS } from '../../errorManagement/errorCatalog';
import { getPromotionsInfo } from '../../utils/normalizers';

export const isClientWithRiskError = (error) => {
  const { response } = error;
  if (
    response
    && response.status === 'KO'
    && response.error
    && response.error.codigoErrorNegocio
    && response.error.codigoErrorNegocio === WEBSERVICE_ERRORS.CLIENT_WITH_RISK
  ) {
    return true;
  }
  return false;
};

export const isClientWithRiskDocNeededError = (error) => {
  const { response } = error;

  if (
    response
    && response.status === 'KO'
    && response.error
    && response.error.codigoErrorNegocio
    && response.error.codigoErrorNegocio
      === WEBSERVICE_ERRORS.CLIENT_RISK_DOC_NEEDED
  ) {
    return true;
  }
  return false;
};

/**
 * Obtiene el listado de promociones aplicadas
 * @param {object} getCQPricesInfo Información que nos viene del api getCQPrices
 * @returns Información de precios normalizada para el carrito
 */
export const getAppliedPromotions = (components, withoutMaintainedPromotions = false) => {
  const appliedPromotions = [];
  if (components.recurringCharges) {
    const { items } = components.recurringCharges;

    if (Array.isArray(items) && items.length > 0) {
      items.forEach((cartItem) => {
        if (
          cartItem
          && cartItem.customerQuoteItems
          && Array.isArray(cartItem.customerQuoteItems)
        ) {
          cartItem.customerQuoteItems.forEach((cqItem) => {

            const { promotions } = getPromotionsInfo(cqItem, withoutMaintainedPromotions);

            promotions.forEach(promotion => {
              appliedPromotions.push(promotion.id);
            });
          });
        }
      });
    }
  }
  if (components.oneTimeCharges) {
    const { items } = components.oneTimeCharges;
    if (Array.isArray(items) && items.length > 0) {
      items.forEach((cartItem) => {
        if (
          cartItem
          && cartItem.customerQuoteItems
          && Array.isArray(cartItem.customerQuoteItems)
        ) {
          cartItem.customerQuoteItems.forEach((cqItem) => {
            const { promotions } = getPromotionsInfo(cqItem, withoutMaintainedPromotions);

            promotions.forEach(promotion => {
              appliedPromotions.push(promotion.id);
            });
          });
        }
      });
    }
  }
  const promotionsWithoutDuplicates = [...new Set(appliedPromotions)];
  return promotionsWithoutDuplicates;
};

export const isR2RWithoutRequiredDataToSign = (response) => {
  return (
    !response
    || (response
      && (!response.phoneNumbersOTP
        || !Array.isArray(response.phoneNumbersOTP)
        || (Array.isArray(response.phoneNumbersOTP)
          && response.phoneNumbersOTP.length === 0)))
  );
};
